var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideos = function SvgVideos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M14.167 2A3.843 3.843 0 0 1 18 5.833v8.334A3.843 3.843 0 0 1 14.167 18H5.833A3.843 3.843 0 0 1 2 14.167V5.833A3.843 3.843 0 0 1 5.833 2zm-8.333.5v15M17.5 6.25h-3.334m-8.333 0H2.5m15 7.5h-3.334m-8.333 0H2.5m15-3.75h-3.334m-8.333 0H2.5m11.667-7.5v15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.333 10h3.333M10 8.334v3.333"
  })));
};
export default SvgVideos;